export default {"src":"/_next/static/media/Header.437a6ba6.svg","height":37,"width":212,"blurWidth":0,"blurHeight":0};